import { DatePipe } from '@angular/common';
import { Injectable ,OnDestroy, Renderer2, ElementRef,HostListener  } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonControlService } from 'projects/data-portal/src/app/core/services/common-control.service';
import { CustomSortingService } from 'projects/data-portal/src/app/core/sort/custom-sorting.service';
import { SearchFieldsControlInfoService } from './search-fields-control-info';
import { ViewerService } from '../../../../services/viewer-service';
import { AppConfigService } from '../../../../core/config/app-config.service';


@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-search-fields',
  templateUrl: './search-fields.component.html',
  styleUrls: ['./search-fields.component.css']
})
export class SearchFieldsComponent implements OnInit,OnDestroy  {

  searchFields: FormGroup;
  columns: string[];
  appealsData: any[];
  errorFromServer: boolean = false;
  formItems: any[];
  metadata: any;
  rtn:any;
  listofRTN:any;
  public selectRTN = '';  
  public flag: boolean = true;  

  listofChemical:any;
  public selectChemical = '';  


  constructor(private fb: FormBuilder,
    private router: Router,
    private datePipe: DatePipe,
    private SpinnerService: NgxSpinnerService,
    private service: SearchFieldsControlInfoService,
    private commonControlService: CommonControlService,
    private customSortingService: CustomSortingService,
    private viewerService: ViewerService,
    private renderer: Renderer2) { }

  ngOnInit(): void {
    this.loadInitializeComponent();
  }

   @HostListener("click") 
    clicked() { 
       var items:any = document.getElementsByClassName('form-popup');
        for (let i = 0; i < items.length; i++) {
            let element = items[i];
            element.style.display = 'none';
        }
    } 

  loadInitializeComponent() {
    debugger;
    if (this.metadata == undefined) {
      this.SpinnerService.show();
      this.formItems = this.service.getSearchFieldsProperties();
      this.searchFields = this.commonControlService.toFormGroup(this.formItems);
      this.viewerService.getApplicationMetadata().subscribe(
        (allMetadata) => {
          this.metadata = allMetadata
          this.formItems.forEach(arrayItem => {
            arrayItem.forEach(item => {
              if (item.type == 'dropdown' && item.key.includes('siteType'))
              {
                item.options = this.metadata.siteType
                this.setControlValue(item.key);
              }
              if (item.type == 'dropdownWithValueforCity' && item.key.includes('townName'))
              {
                item.options = this.metadata.townName
                this.setControlValue(item.key);
              }
                
              if (item.type == 'dropdown' && item.key.includes('regulatoryStatus'))
                {
                  item.options = this.metadata.regulatoryStatus
                  this.setControlValue(item.key);
                }
               
              if (item.type == 'dropdownWithValue' && item.key.includes('lsp'))
                {
                  item.options = this.metadata.lsp
                  this.setControlValue(item.key);
                }
                
              if (item.type == 'dropdownWithValue' && item.key.includes('zipCode'))
                {
                  item.options = this.metadata.zipCode
                  this.setControlValue(item.key);
                }
                
              // if (item.type == 'dropdownWithValueforRTN' && item.key.includes('rtn'))
              //   {
              //     this.setControlValue(item.key);
              //   }
                 
              if (item.type == 'text' && item.key.includes('rtn'))
                {
                  debugger;
                  this.setControlValue(item.key);
                }
              if (item.type == 'text' && item.key.includes('address'))
                  {
                    this.setControlValue(item.key);
                  }
              if (item.type == 'text' && item.key.includes('siteName'))
                    {
                      this.setControlValue(item.key);
                    }
              // if (item.type == 'dropdown' && item.key.includes('chemical'))
              //     {
              //           item.options = this.metadata.chemical
              //           this.setControlValue(item.key);
              //     } 
                if (item.type == 'dropdownWithValueforChemical' && item.key.includes('chemical'))
                {
                  this.setControlValue(item.key);
                }

            });
          });
          localStorage.clear();
          this.SpinnerService.hide();
        }, (err) => {
          this.SpinnerService.hide();
          alert("Internal Server Error - Something went Wrong");
        });
    }
    else {
      this.formItems = this.service.getSearchFieldsProperties();
      this.searchFields = this.commonControlService.toFormGroup(this.formItems);
      this.formItems.forEach(arrayItem => {
        arrayItem.forEach(item => {
          if (item.type == 'dropdown' && item.key.includes('siteType'))
            item.options = this.metadata.siteType
          if (item.type == 'dropdownWithValueforCity' && item.key.includes('townName'))
            item.options = this.metadata.townName
          if (item.type == 'dropdown' && item.key.includes('regulatoryStatus'))
            item.options = this.metadata.regulatoryStatus
          if (item.type == 'dropdownWithValue' && item.key.includes('lsp'))
            item.options = this.metadata.lsp
          if (item.type == 'dropdownWithValue' && item.key.includes('zipCode'))
            item.options = this.metadata.zipCode
        });
      });
    }

  }

  // searchClient(rtn: string): void {  
  //   debugger;
  //   // rtn=this.searchFields.controls["selectRTN"].value

  // }  
  
  viewerSearch() {
    let queryString = ""
    let itemName = ""
    this.formItems.forEach(arrayItem => {
      arrayItem.forEach(item => {
        debugger;
        if (item.type == 'dropdown' && item.key.includes('siteType')) {
          if (this.searchFields.controls[item.key].value.length > 0) {
            queryString += item.key + ":" + this.searchFields.controls[item.key].value + "_";
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }
          else{
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }
        }
        if (item.type == 'dropdownWithValueforCity' && item.key.includes('townName')) {
          if (this.searchFields.controls[item.key].value.length > 0) {
            queryString += item.key + ":" + this.searchFields.controls[item.key].value + "_";
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }else{
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }
        }
        if (item.type == 'dropdown' && item.key.includes('regulatoryStatus')) {
          if (this.searchFields.controls[item.key].value.length > 0) {
            queryString += item.key + ":" + this.searchFields.controls[item.key].value + "_";
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }else{
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }
        }
        if (item.type == 'dropdownWithValue' && item.key.includes('lsp')) {
          if (this.searchFields.controls[item.key].value.length > 0) {
            queryString += item.key + ":" + this.searchFields.controls[item.key].value + "_";
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }else{
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }
        }
        // if (item.type == 'dropdownWithValueforRTN' && item.key.includes('rtn')) {
        //   // if (this.getItem(item.key).length > 0) {
        //   //   queryString += item.key + ":" + this.getItem(item.key) + "_";
        //   //   this.setItem(item.key,this.getItem(item.key));
        //   // }else{
        //   //   this.setItem(item.key,this.getItem(item.key));
        //   // }

        //   debugger;
        //   if (this.searchFields.controls[item.key].value.length > 0) {
        //     queryString += item.key + ":" + this.searchFields.controls[item.key].value + "_";
        //     this.setItem(item.key,this.searchFields.controls[item.key].value);
        //   }else{
        //     this.setItem(item.key,this.searchFields.controls[item.key].value);
        //   }

        // }

        if (item.type == 'text' && item.key.includes('rtn')) {
          debugger;
          if (this.searchFields.controls[item.key].value.length > 0) {
            var value=this.searchFields.controls[item.key].value;
            if(this.searchFields.controls[item.key].value.length<9)
                value=this.searchFields.controls[item.key].value.split("-")[0] +"-"+ this.searchFields.controls[item.key].value.split("-")[1].toString().padStart(7, '0');
            
            queryString += item.key + ":" + value + "_";
            this.setItem(item.key,value);
          }else{
            this.setItem(item.key,value);
          }
        }

        if (item.type == 'text' && item.key.includes('address')) {
          if (this.searchFields.controls[item.key].value.length > 0) {
            queryString += item.key + ":" + this.searchFields.controls[item.key].value + "_";
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }else{
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }
        }
        if (item.type == 'text' && item.key.includes('siteName')) {
          if (this.searchFields.controls[item.key].value.length > 0) {
            queryString += item.key + ":" + this.searchFields.controls[item.key].value + "_";
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }else{
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }
        }
        if (item.type == 'dropdownWithValue' && item.key.includes('zipCode')) {
          if (this.searchFields.controls[item.key].value.length > 0) {
            queryString += item.key + ":" + this.searchFields.controls[item.key].value + "_";
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }else{
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }
        }
        if (item.type == 'dropdownWithValueforChemical' && item.key.includes('chemical')) {
          if (this.searchFields.controls[item.key].value.length > 0) {
            queryString += item.key + ":" + this.searchFields.controls[item.key].value + "_";
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }else{
            this.setItem(item.key,this.searchFields.controls[item.key].value);
          }
        }
        // if (item.type == 'dropdown' && item.key.includes('chemical')) {
        //   if (this.searchFields.controls[item.key].value.length > 0) {
        //     queryString += item.key + ":" + this.searchFields.controls[item.key].value + "_";
        //     this.setItem(item.key,this.searchFields.controls[item.key].value);
        //   }else{
        //     this.setItem(item.key,this.searchFields.controls[item.key].value);
        //   }
        // }
      })
    })
    queryString = queryString.substring(0, queryString.length - 1);
    this.router.navigate(['/results'], { queryParams: { queryString } });
  }


  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  setControlValue(key: string)
  {
    debugger;
    if(this.getItem(key)!="undefined" && this.getItem(key)!=undefined)
      {
        this.searchFields.controls[key].setValue(this.getItem(key));
      }
  }

  public searchRTN(rtn:any) {
debugger;
this.setItem("rtn",rtn);
 this.viewerService.getRTN(rtn).subscribe(
  (filterRTN) => {
    this.listofRTN = filterRTN
    this.formItems.forEach(arrayItem => {
      debugger;
      arrayItem.forEach(item => {
        if (item.type == 'dropdownWithValueforRTN' && item.key.includes('rtn'))
        {
          debugger;
          item.options = filterRTN
        }
          

      });
    });

  }, (err) => {

    alert("Internal Server Error - Something went Wrong");
  });
}

  public assignSelectedRTN(rtn:any)
  {
    //const element = this.renderer.selectRootElement(`#rtn`);
    // this.renderer.setProperty(element, 'value', rtn);
    this.searchFields.controls["rtn"].setValue(rtn);
  }

  public cityChanges() {
    this.SpinnerService.show();
    this.formItems.forEach(arrayItem => {
      arrayItem.forEach(item => {
        if (item.type == 'dropdownWithValueforCity' && item.key.includes('townName')) {
          debugger;
          var selectedValue = this.searchFields.controls[item.key].value

          this.viewerService.getZipCodeBasedOnCity(selectedValue).subscribe(
            (filterZipCode) => {
              this.metadata = filterZipCode
              this.formItems.forEach(arrayItem => {
                arrayItem.forEach(item => {
                  if (item.type == 'dropdownWithValue' && item.key.includes('zipCode'))
                    item.options = filterZipCode

                });
              });
              this.SpinnerService.hide();
            }, (err) => {
              this.SpinnerService.hide();
              alert("Internal Server Error - Something went Wrong");
            });

        }
      })
    })
  }

  clearSearchFields() {
    this.SpinnerService.show();
    //this.searchFields.reset();
    localStorage.clear();
    this.loadInitializeComponent();
    this.SpinnerService.hide();
  }

  back() {
    localStorage.clear();
    window.history.back();
  }

  ngOnDestroy() {
    // Clear localStorage on component destruction (e.g., when the tab is closed)

  }t

  public searchChemical(chemical:any) {
    debugger;
    this.setItem("chemical",chemical);
    if(chemical.length>2)
    {
      this.viewerService.getChemical(chemical).subscribe(
        (filterChemical) => {
          debugger
          this.listofChemical = filterChemical
          this.formItems.forEach(arrayItem => {
            arrayItem.forEach(item => {
              if (item.type == 'dropdownWithValueforChemical' && item.key.includes('chemical'))
              {
                debugger;
                item.options = filterChemical
              }
                
      
            });
          });
      
        }, (err) => {
      
          alert("Internal Server Error - Something went Wrong");
        });
    }
     
    }
    
      public assignSelectedChemical(chemical:any)
      {
        //const element = this.renderer.selectRootElement(`#rtn`);
        // this.renderer.setProperty(element, 'value', rtn);
        this.searchFields.controls["chemical"].setValue(chemical);
      }

}
